import { NavLink } from "react-router-dom";
import ReactDom from "react-dom";

import classes from "./Footer.module.css";

const FooterContent = () => {
  return (
    <footer>
      <nav className={classes["bottom-menu"]}>
        <ul>
          <li>
            <NavLink
              to="/accueil"
              className={({ isActive }) => {
                let activeClassName = isActive ? classes.active : "";
                return `${activeClassName} ${classes.navlink} ${classes.tab}`;
              }}
            >
              Accueil<i className="material-icons">home</i>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/faire-une-demande"
              className={({ isActive }) => {
                let activeClassName = isActive ? classes.active : "";
                return `${activeClassName} ${classes.navlink} ${classes.tab}`;
              }}
            >
              Transmettre une demande<i className="material-icons">add_box</i>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/mes-demandes"
              className={({ isActive }) => {
                let activeClassName = isActive ? classes.active : "";
                return `${activeClassName} ${classes.navlink} ${classes.tab}`;
              }}
            >
              demandes<i className="material-icons">list</i>
            </NavLink>
          </li>
        </ul>
      </nav>
    </footer>
  );
};
const Footer = () => {
  const portalElement = document.getElementById("overlays");

  return <>{ReactDom.createPortal(<FooterContent />, portalElement)}</>;
};

export default Footer;
